import React from 'react';
import {
    Content,
    ContentVariants,
    Card,
    CardTitle,
    CardBody,
    CardFooter,
    Level,
    LevelItem,
    DescriptionList,
    DescriptionListGroup,
    DescriptionListTerm,
    DescriptionListDescription,
    Title,
    Divider,
    List,
    ListItem,
    Label,
    LabelColor
} from '@patternfly/react-core';

const Panel = ({ data }) => {
    const IconComponent = data.icon;
    
    return (
        <Card isFullHeight isGlass>
            <CardTitle>
                <Level>
                    <LevelItem>
                        <Label
                            variant="outline"
                            color={LabelColor.blue}
                        >
                            {data.category}
                        </Label>
                    </LevelItem>

                    <LevelItem>
                        <IconComponent  {...data.iconProps} />
                    </LevelItem>
                </Level>
            </CardTitle>

            <CardBody>
                <DescriptionList>
                    <DescriptionListGroup>
                        <DescriptionListTerm>
                            <Title headingLevel="h5" size="md">
                                {data.title}
                            </Title>
                        </DescriptionListTerm>
                        <Divider />
                        <DescriptionListDescription>
                            <Content component={ContentVariants.small}>{data.description}</Content>
                        </DescriptionListDescription>
                    </DescriptionListGroup>

                    <DescriptionListGroup>
                        <List>
                            {data.items.map((item, index) => (
                                <ListItem key={index}>
                                    <Content component={ContentVariants.small}>{item}</Content>
                                </ListItem>
                            ))}
                        </List>
                    </DescriptionListGroup>
                </DescriptionList>
            </CardBody>

            <Divider />

            <CardFooter>
                <Content
                    component={ContentVariants.a}
                    href={data.link}
                    target="_blank"
                >
                    Zobacz więcej
                </Content>
            </CardFooter>
        </Card>
    );
};

export default Panel;